import React from "react";
import "./InfoIcon.css";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";

function InfoIcon({ position, infoText, noIcon }) {
  return (
    <div className="info_area">
      {noIcon ? null : (
        <InfoOutlinedIcon className="info_icon"></InfoOutlinedIcon>
      )}
      <span className={`info_text ${position}`}>
        <p>{infoText}</p>
      </span>
    </div>
  );
}

export default InfoIcon;
